import { FlightStatus } from "../types/FlightStatus";
import { FlightAwareStatus } from "../types/FlightAwareStatus";
import { DisplayFlight, DateTimeWithTimezone } from "../types/DisplayFlight";

export const colorForFaFlightStatus = (status: FlightAwareStatus): string => {
  if (status.cancelled || status.diverted) {
    return "danger";
  } else if (status.arrival_delay >= 300) {
    //300 seconds == 5 mins
    return "danger";
  } else {
    return "success";
  }
};

export const flightStatuses: {
  [key: string]: { longStatusText: string; statusText: string; color: string };
} = {
  "100": {
    longStatusText: "Not Monitorable",
    statusText: "Unmonitored",
    color: "primary",
  },
  "200": {
    longStatusText: "Not Monitored",
    statusText: "Unmonitored",
    color: "primary",
  },
  "300": {
    longStatusText: "Scheduled",
    statusText: "Scheduled",
    color: "primary",
  },
  "301": { longStatusText: "On Time", statusText: "On Time", color: "success" },
  "302": {
    longStatusText: "In Flight - On Time",
    statusText: "In Flight - On Time",
    color: "success",
  },
  "303": {
    longStatusText: "Arrived - On Time",
    statusText: "Arrived - On Time",
    color: "success",
  },
  "400": {
    longStatusText: "Cancelled",
    statusText: "Cancelled",
    color: "danger",
  },
  "401": { longStatusText: "Delayed", statusText: "Delayed", color: "danger" },
  "402": {
    longStatusText: "In Flight - Late",
    statusText: "In Flight",
    color: "danger",
  },
  "403": {
    longStatusText: "Arrived - Late",
    statusText: "Arrived",
    color: "danger",
  },
  "404": {
    longStatusText: "Diverted",
    statusText: "Diverted",
    color: "danger",
  },
  "405": {
    longStatusText: "Possibly Delayed",
    statusText: "Poss Delayed",
    color: "danger",
  },
  "406": {
    longStatusText: "In Flight - Possibly Late",
    statusText: "In Flight",
    color: "danger",
  },
  "407": {
    longStatusText: "Arrived - Possibly Late",
    statusText: "Arrived",
    color: "danger",
  },
  "408": { longStatusText: "Unknown", statusText: "Unknown", color: "primary" },
};

export const IATAToICAO: { [key: string]: string } = {
  PR: "BOI",
  "2T": "TBS",
  Q5: "MLA",
  "4D": "ASD",
  "4R": "SEK",
  "4O": "AIJ",
  "7A": "XRC",
  "7B": "UBE",
  "7S": "RYA",
  RL: "ABG",
  W9: "AAB",
  M3: "TUS",
  GB: "ABX",
  ZA: "CYD",
  VX: "AES",
  KI: "DHI",
  "Z7*": "ADK",
  JP: "ADR",
  AN: "WSN",
  A3: "AEE",
  "9D": "CND",
  ML: "AEK",
  DW: "UCR",
  SU: "AFL",
  P3: "PLS",
  OB: "AAT",
  SM: "AAW",
  KJ: "AAZ",
  YE: "ACQ",
  VJ: "AFF",
  QH: "FLA",
  "3O": "MAC",
  HD: "ADO",
  UJ: "LMU",
  A2: "AWG",
  X9: "NVD",
  "3S*": "AEN",
  JU: "ASL",
  XK: "CCM",
  EI: "EIN",
  A8: "XAU",
  RV: "ROU",
  "6U": "ACX",
  ZI: "AAF",
  AE: "AE",
  "4K*": "AAS",
  "8U": "AAW",
  Q9: "AFU",
  QB: "AAJ",
  LD: "AHK",
  "2Y": "ADW",
  UX: "AEA",
  IG: "AEY",
  NX: "AMU",
  ZV: "AMW",
  HM: "SEY",
  AF: "AFR",
  SB: "ACI",
  EH: "AKX",
  ED: "AXE",
  ZW: "AWI",
  YI: "RSI",
  GN: "AGN",
  "9T": "RUN",
  ZB: "ABN",
  "3J": "AAQ",
  WP: "ATW",
  BX: "ABL",
  LB: "LEP",
  GL: "GRL",
  "3S": "GUY",
  NQ: "AJX",
  IJ: "LIB",
  TT: "KLA",
  QM: "AIM",
  L6: "AMI",
  P8: "MKG",
  ZQ: "MNE",
  NZ: "ANZ",
  "4N": "ANT",
  ZX: "ABL",
  G8: "AGB",
  "7T": "AGV",
  "6V": "VGA",
  NH: "ANA",
  TZ: "TWG",
  "2Q": "SNC",
  V7: "SNG",
  AB: "BER",
  QN: "ARR",
  AI: "AIC",
  PJ: "SPM",
  SZ: "WOW",
  "8C": "ATN",
  NF: "AVN",
  CC: "ABD",
  RB: "SBK",
  TN: "THT",
  SW: "NMB",
  AW: "AFW",
  PE: "AEL",
  JM: "AJM",
  "6G": "AWW",
  TX: "FWI",
  IX: "AXB",
  BT: "BTI",
  EL: "ANK",
  YW: "ANE",
  PX: "ANG",
  G9: "ABY",
  AC: "ACA",
  AP: "LAV",
  E9: "MHS",
  XT: "AXL",
  UM: "AZW",
  S2: "RSH",
  TC: "ATC",
  "2J": "VBW",
  KM: "AMC",
  YT: "TGA",
  G4: "AAY",
  O4: "ABV",
  "8T": "TID",
  "3L": "ADY",
  "EM*": "AEB",
  KD: "AEN",
  "5W": "AEU",
  VV: "AEW",
  WK: "AFB",
  QQ: "UTY",
  FG: "AFG",
  "RV*": "AFI",
  Y2: "AFJ",
  "5Z": "AFX",
  "5D": "SLI",
  "1A": "AGT",
  JJ: "AGX",
  PL: "PLI",
  "8A": "BMM",
  GD: "AHA",
  HT: "AHW",
  J2: "AHY",
  U3: "AIA",
  "4Y": "AIB",
  RS: "ASV",
  "5A": "AIP",
  "ED*": "ABQ",
  W4: "BES",
  IZ: "AIZ",
  M6: "AJT",
  "4A": "AKL",
  EV: "ASQ",
  HP: "AWE",
  "6R": "TNO",
  VH: "ALV",
  DP: "AMM",
  AM: "AMX",
  TL: "ANO",
  OY: "ANS",
  IW: "AOM",
  J6: "AOC",
  "2D": "AOG",
  VB: "VIV",
  OE: "AOT",
  GV: "ARF",
  JW: "APW",
  "2B": "AWT",
  "4C": "ARE",
  AR: "ARG",
  AS: "ASA",
  HC: "ATI",
  FO: "ATM",
  OS: "AUA",
  IQ: "AUB",
  RU: "ABW",
  GR: "AUR",
  NO: "AUS",
  AU: "AUT",
  K8: "ZAK",
  B9: "BGD",
  AK: "AXM",
  D7: "XAX",
  DJ: "WAJ",
  I5: "IAD",
  EX: "BJK",
  "3G": "AYZ",
  AZ: "AZA",
  ZE: "AZE",
  R7: "OCA",
  RX: "AEH",
  MQ: "EGF",
  ZS: "AZI",
  WI: "WIL",
  VU: "VUN",
  BP: "BOT",
  GS: "UPA",
  VT: "VTA",
  "3N": "URG",
  VL: "VIM",
  FK: "WTA",
  G2: "VXG",
  V8: "VAS",
  K6: "KHV",
  CA: "CCA",
  Q6: "CDP",
  "5F": "CIR",
  QC: "CRD",
  NV: "CRF",
  CV: "CVA",
  CW: "CWM",
  AH: "DAH",
  ER: "DHL",
  EN: "DLA",
  NM: "DRD",
  EE: "EAY",
  "4F": "ECE",
  E8: "ELG",
  RF: "EOK",
  KY: "EQL",
  PC: "FAJ",
  JH: "FDA",
  OF: "FIF",
  FJ: "FJI",
  RC: "FLI",
  NY: "FXI",
  "2P": "GAP",
  "2U": "GIP",
  "0A": "GNT",
  DA: "GRG",
  LL: "GRO",
  "5Y": "GTI",
  GG: "GUY",
  H9: "HAD",
  IP: "JOL",
  QK: "JZA",
  KK: "KKK",
  JS: "KOR",
  KC: "KZR",
  LV: "LBC",
  QP: "AKJ",
  D4: "LID",
  "9I": "LLR",
  XL: "LNE",
  "4Z": "LNK",
  FL: "LPA",
  A6: "LPV",
  TD: "LUR",
  L8: "LXG",
  LK: "LXR",
  MK: "MAU",
  MD: "MDG",
  "9U": "MLD",
  L9: "MLI",
  A7: "MPD",
  QO: "MPX",
  MR: "MRT",
  F4: "NBK",
  AJ: "NIG",
  "8Y": "PBU",
  OT: "PEL",
  AD: "PRZ",
  QD: "QCL",
  QS: "QSC",
  AG: "ARU",
  MC: "RCH",
  RE: "REA",
  UU: "REU",
  ZP: "AZP",
  "6K": "RIT",
  A5: "RLA",
  QL: "RLN",
  R3: "RME",
  MV: "RML",
  "2O": "RNE",
  U8: "RNV",
  BQ: "ROM",
  P5: "RPB",
  E4: "RSO",
  BF: "RSR",
  "5L": "RSU",
  JR: "SER",
  Z3: "SMJ",
  "8D*": "SUW",
  GM: "SVK",
  VW: "TAO",
  JY: "TCI",
  CG: "TOK",
  TY: "TPC",
  TS: "TSC",
  EC: "TWN",
  U7: "UGA",
  KO: "AER",
  KH: "AAH",
  AQ: "AAH",
  AA: "AAL",
  "WD*": "AAN",
  HO: "DJA",
  OZ: "AAR",
  "8V": "ACP",
  XM: "XME",
  AO: "AUZ",
  VE: "AVE",
  "6A": "CHP",
  AV: "AVA",
  A0: "MCJ",
  O6: "ONE",
  "2K": "GLG",
  V5: "VLI",
  CJ: "CFE",
  TH: "BRT",
  B4: "BCF",
  UP: "BHS",
  "8Q*": "BAJ",
  V9: "BTC",
  BA: "BAW",
  BG: "BBC",
  BO: "BBD",
  SI: "BCI",
  WX: "BCY",
  BZ: "BDA",
  JA: "BON",
  J4: "BFL",
  "8H": "BGH",
  U4: "BHA",
  UH: "BHL",
  "4T": "BHP",
  BS: "BIH",
  PG: "BKP",
  KF: "BLF",
  JV: "BLS",
  B3: "BLV",
  BD: "BMA",
  BM: "BMR",
  WW: "BMI",
  CH: "BMJ",
  BN: "BNF",
  BV: "BPA",
  "7R": "BRB",
  "8E": "BRG",
  B2: "BRU",
  GQ: "BSY",
  ID: "BTK",
  "4B": "BTQ",
  Y6: "BTV",
  "1T": "BUC",
  BU: "BUN",
  J8: "BVT",
  QW: "BWG",
  SN: "BXI",
  DB: "BZH",
  JD: "CBJ",
  NT: "IBB",
  "0B": "BLA",
  FB: "LZB",
  "8N": "NKF",
  YB: "BRJ",
  MX: "MXY",
  "7N": "PWD",
  KR: "KME",
  "5C": "ICL",
  "3C": "CMV",
  MO: "CAV",
  R9: "CAM",
  UY: "UYC",
  C6: "CJA",
  CP: "CDN",
  "7F": "AKT",
  W2: "CWA",
  "9K": "KAP",
  PT: "CCI",
  "2G": "CRG",
  W8: "CJT",
  C8: "ICV",
  BW: "BWA",
  "8B": "GFI",
  V3: "KRP",
  KA: "HDA",
  CX: "CPA",
  KX: "CAY",
  "5J": "CEB",
  "9M": "GLR",
  J7: "CVC",
  WE: "CWC",
  OP: "CHK",
  MG: "CCP",
  "2Z": "CGN",
  S8: "CSU",
  "RP*": "CHQ",
  CI: "CAL",
  CK: "CKK",
  MU: "CES",
  G5: "HXA",
  WH: "CNW",
  CZ: "CSN",
  KN: "CUA",
  XO: "CXH",
  "3Q": "CYH",
  X7: "CHF",
  OQ: "CQN",
  QI: "CIM",
  C7: "CIN",
  C9: "RUS",
  G3: "CIX",
  CT: "CAT",
  "6P": "ISG",
  "9L": "CJC",
  YD: "CAT",
  OH: "COM",
  MN: "CAW",
  C5: "UCA",
  DE: "CFG",
  CO: "COA",
  CS: "CMI",
  V0: "VCV",
  CM: "CMP",
  CQ: "CCW",
  XC: "CAI",
  CD: "CND",
  LF: "VTE",
  SS: "CRL",
  F5: "COZ",
  "7C": "COY",
  OU: "CTN",
  QE: "ECC",
  CU: "CUB",
  CY: "CYP",
  YK: "KYV",
  OK: "CSA",
  "8L": "CGP",
  XG: "CLI",
  PN: "CHB",
  WD: "DSR",
  DX: "DTR",
  D0: "DHK",
  ES: "DHX",
  L3: "JOS",
  D3: "DAO",
  N2: "DAG",
  H8: "KHB",
  DD: "DDL",
  "0D": "DWT",
  D5: "DAU",
  DL: "DAL",
  "1I": "AMB",
  DH: "DVA",
  Z6: "UDN",
  YU: "ADM",
  DO: "DOA",
  E3: "DMO",
  D9: "DNV",
  KB: "DRK",
  DI: "BAG",
  "9E": "EDV",
  H7: "EGU",
  "9A": "EZX",
  S9: "HSA",
  EA: "EAL",
  T3: "EZE",
  QF: "EAQ",
  DK: "ELA",
  DS: "EZS",
  U2: "EZY",
  MS: "MSR",
  LY: "ELY",
  UZ: "BRQ",
  EK: "UAE",
  EM: "CFS",
  EU: "EEA",
  E0: "ESS",
  B8: "ERT",
  E7: "ESF",
  OV: "ELL",
  ET: "ETH",
  EY: "ETD",
  MM: "MMZ",
  UI: "ECA",
  GJ: "EEZ",
  K2: "ELO",
  "3W": "EMX",
  "5O": "FPO",
  QY: "BCS",
  EW: "EWG",
  E2: "EWE",
  BR: "EVA",
  EZ: "EIA",
  ZD: "EWR",
  JN: "XLA",
  MB: "EXA",
  OW: "EXK",
  EO: "LHN",
  FE: "FEA",
  F6: "RCK",
  F3: "FSW",
  FX: "FDX",
  N8: "HGK",
  "4S": "FNC",
  AY: "FIN",
  FC: "WBA",
  FY: "FFM",
  "8F": "FFR",
  "8D": "EXV",
  B5: "FLT",
  PA: "FCL",
  F2: "FLM",
  "8W": "EDR",
  G6: "ACY",
  "9Y": "FGE",
  OJ: "FJM",
  "9P": "FJL",
  SH: "FLY",
  F7: "BBO",
  BE: "BEE",
  FT: "FEG",
  SX: "TOR",
  W3: "FYH",
  TE: "LIL",
  XY: "KNE",
  FS: "FOX",
  VK: "FVK",
  VY: "FOS",
  HK: "FSC",
  FH: "FHY",
  SJ: "FOM",
  F9: "FFT",
  "2F": "FTA",
  FZ: "FDB",
  Y5: "GMR",
  GT: "GBL",
  Z5: "GMG",
  "7O": "GAL",
  GC: "GNR",
  G7: "GNF",
  GA: "GIA",
  "4G": "GZP",
  A9: "TGZ",
  HE: "LGW",
  ST: "GMI",
  "4U": "GWI",
  GP: "RIV",
  GH: "GLP",
  G0: "GHB",
  DC: "GAO",
  ZK: "GLA",
  HB: "HGB",
  J9: "GIF",
  GF: "GFA",
  H6: "HAG",
  HR: "HHN",
  HU: "CHH",
  X3: "HLX",
  HF: "HLF",
  HQ: "HMY",
  HA: "HAL",
  HN: "HVY",
  JB: "JBA",
  ZU: "HCY",
  HJ: "HEJ",
  HW: "FHE",
  "2L": "OAW",
  UD: "HER",
  "5K": "HFY",
  VM: "VMS",
  H5: "HOA",
  HX: "CRK",
  RH: "HKC",
  UO: "HKE",
  QX: "QXE",
  I4: "EXP",
  IK: "KAR",
  IB: "IBE",
  II: "CSQ",
  I2: "IBS",
  FW: "IBX",
  "0C": "IBL",
  C3: "IPR",
  FI: "ICE",
  I7: "IOA",
  "6E": "IGO",
  IC: "IAC",
  I9: "IBU",
  VP: "AXC",
  QZ: "AWQ",
  IO: "IAA",
  C4: "IMX",
  H4: "IIN",
  D6: "ILN",
  "N/A": "NCC",
  "6I": "IBZ",
  IR: "IRA",
  EP: "IRC",
  IA: "IAW",
  IH: "MZA",
  "2S": "SDY",
  IF: "ISW",
  WC: "ISV",
  "6H": "ISR",
  GI: "IKA",
  JC: "JEX",
  JO: "JAZ",
  MT: "JMC",
  JI: "JAE",
  "3X": "JAC",
  JL: "JAL",
  EG: "JAA",
  NU: "JTA",
  O2: "JEA",
  "9W": "JAI",
  PP: "PJS",
  "3K": "JSA",
  LS: "EXS",
  B6: "JBU",
  JF: "JAA",
  "0J": "JCS",
  SG: "JGO",
  JQ: "JST",
  GK: "JJP",
  JX: "JEC",
  GX: "JXX",
  LJ: "JNA",
  R5: "JAV",
  XE: "JSX",
  "6J": "JUB",
  KW: "KHK",
  WA: "KLC",
  KL: "KLM",
  K4: "CKS",
  K9: "KFS",
  "CB*": "KII",
  RQ: "KMF",
  V2: "AKT",
  KV: "MVD",
  M5: "KEN",
  KQ: "KQA",
  ZN: "KEY",
  KG: "LYM",
  IT: "KFR",
  "4I": "KNX",
  Y9: "IRK",
  KP: "KIA",
  "7K": "KGL",
  "8J": "KMV",
  KE: "KAL",
  GW: "KIL",
  VD: "KPA",
  KU: "KAC",
  GO: "KZU",
  N5: "KGZ",
  R8: "KGA",
  YQ: "LCT",
  LR: "LRC",
  "4M": "DSM",
  UC: "LCO",
  LA: "LAN",
  LU: "LXP",
  PZ: "LAP",
  LP: "LPE",
  LO: "LOT",
  LT: "LTU",
  N6: "JEV",
  QV: "LAO",
  L7: "LPN",
  NG: "LDA",
  "OE[36]": "LDM",
  LQ: "LAQ",
  LI: "LIA",
  LN: "LAA",
  TM: "LAM",
  JT: "LNI",
  LM: "LVG",
  LH: "DLH",
  CL: "CLH",
  L5: "LTR",
  LG: "LGL",
  "5V": "UKW",
  L2: "LYC",
  L4: "SSX",
  Z8: "AZN",
  MJ: "LPR",
  Q2: "DQA",
  OD: "MXD",
  M7: "MAA",
  MH: "MWG",
  IN: "MAK",
  OM: "MGL",
  DM: "DAN",
  W5: "IRM",
  M2: "MZS",
  TF: "SCW",
  MA: "MAH",
  RI: "MDL",
  JE: "MNO",
  MP: "MPH",
  "8M": "MXL",
  MY: "MXJ",
  MW: "MYD",
  "7M": "MYI",
  M8: "MKN",
  IM: "MNJ",
  MZ: "MNA",
  YV: "ASH",
  XJ: "MES",
  ME: "MEA",
  YX: "MEP",
  M4: "MSA",
  "2M": "MDV",
  YM: "MGX",
  "5M": "MNT",
  "3R": "GAI",
  M9: "MSI",
  N4: "MTC",
  Z9: "MYM",
  VZ: "MYT",
  UB: "UBA",
  ZT: "AWC",
  "6N": "NIN",
  DV: "ACK",
  UE: "NAS",
  N7: "ROK",
  NA: "NAL",
  NC: "NJS",
  CE: "NTW",
  RA: "RNA",
  EJ: "NEA",
  "2N": "NTJ",
  HG: "NLY",
  KZ: "NCA",
  XW: "NCT",
  "5N": "AUL",
  Y7: "TYA",
  N0: "NBT",
  "7H": "RVF",
  NW: "NWA",
  J3: "PLR",
  "D8*": "IBK",
  DY: "NOZ",
  DN: "NAA",
  DU: "NLH",
  D8: "NSZ",
  BJ: "LBT",
  O9: "NOV",
  VQ: "NVQ",
  UQ: "OCM",
  O8: "OHK",
  VC: "VCX",
  OL: "OLT",
  OA: "OAL",
  WY: "OMA",
  "8Q": "OHY",
  R2: "ORB",
  OX: "OEA",
  ON: "RON",
  O7: "OZJ",
  PV: "PNR",
  "9Q": "PBA",
  PU: "PUA",
  BL: "PIC",
  "8P": "PCO",
  Q8: "PEC",
  LW: "NMI",
  PK: "PIA",
  PF: "PNW",
  NR: "PIR",
  KS: "PEN",
  P9: "PGP",
  Z2: "EZD",
  "9R": "VAP",
  PI: "PDT",
  PO: "PAC",
  PH: "PAO",
  PD: "POE",
  NI: "PGA",
  BK: "PDC",
  PW: "PRF",
  TO: "PSD",
  P6: "PVG",
  P0: "PFZ",
  PB: "SPR",
  FV: "PLK",
  QR: "QTR",
  V4: "REK",
  YS: "RAE",
  FN: "RGL",
  ZL: "RXA",
  P7: "REP",
  RW: "RPA",
  SL: "RSL",
  GZ: "RAR",
  RR: "RFR",
  AT: "RAM",
  R0: "RPK",
  BI: "RBA",
  RJ: "RJA",
  RK: "RCT",
  WR: "HRH",
  WB: "RWD",
  RD: "RYN",
  FR: "RYR",
  RT: "BUG",
  TR: "TGW",
  "6Y": "ART",
  "3Z": "TVP",
  "6D": "TVQ",
  N9: "SHA",
  "7E": "AWU",
  S4: "RZO",
  SA: "SAA",
  W7: "SAH",
  NL: "SAI",
  SK: "SAS",
  UG: "SEN",
  S7: "SBI",
  Q7: "SBM",
  BB: "SBS",
  S5: "SDG",
  K5: "SQH",
  SY: "SCX",
  I6: "SEQ",
  "7G": "SFJ",
  FA: "SFR",
  HZ: "SHU",
  SP: "SAT",
  ZY: "SHY",
  SQ: "SIA",
  "3M": "SIL",
  XS: "SIT",
  D2: "SSF",
  "5G": "SSV",
  SD: "SUD",
  SV: "SVA",
  WN: "SWA",
  A4: "SWD",
  WG: "SWG",
  WQ: "SWQ",
  LX: "SWR",
  SR: "SWR",
  "LZ[56]": "SWU",
  WV: "SWV",
  Q4: "SWX",
  WO: "WSW",
  XQ: "SXS",
  AL: "SYX",
  "7L": "AZG",
  E5: "BRZ",
  SC: "CDG",
  "9C": "CQH",
  "3U": "CSC",
  FM: "CSH",
  ZH: "CSZ",
  NE: "ESK",
  SO: "HKA",
  JK: "JKK",
  "RZ*": "LRS",
  "2G*": "MRR",
  "1Z": "APD",
  NK: "NKS",
  S0: "OKS",
  VA: "OZW",
  S3: "BBR",
  H2: "SKU",
  OO: "SKW",
  JZ: "SKX",
  BC: "SKY",
  MI: "SLK",
  "6Q": "SLL",
  PY: "SLM",
  NB: "SNB",
  IE: "SOL",
  "6W": "SOV",
  O3: "CSS",
  PQ: "SQP",
  P2: "LLI",
  "5P": "LLX",
  UL: "ALK",
  DG: "SRQ",
  "1L": "OSY",
  DT: "DTA",
  VR: "TCV",
  TI: "TWI",
  EQ: "TAE",
  QT: "TPA",
  TQ: "TDM",
  TP: "TAP",
  K3: "TQN",
  RO: "ROT",
  SF: "DTH",
  T6: "TVR",
  T2: "TCG",
  FD: "AIQ",
  TG: "THA",
  T9: "TSX",
  "3P": "TNM",
  "3V": "TAY",
  TJ: "GPD",
  AX: "LOF",
  TW: "TWA",
  UN: "TSO",
  GE: "TNA",
  HV: "TRA",
  GY: "TMG",
  T4: "TIB",
  PM: "TOS",
  BY: "TOM",
  TB: "JAF",
  OR: "TFL",
  "6B": "BLX",
  TU: "TAR",
  "3T": "URN",
  TK: "THY",
  T5: "TUA",
  T7: "TJT",
  VO: "TYR",
  U5: "GWY",
  B7: "UIA",
  UA: "UAL",
  "4H": "UBD",
  U6: "SVR",
  QU: "UGA",
  UR: "UGD",
  UF: "UKM",
  "6Z": "UKS",
  "5X": "UPS",
  US: "AWE",
  UT: "UTA",
  HY: "UZB",
  PS: "AUI",
  VF: "VLU",
  "0V": "VFC",
  VN: "HVN",
  "KWA\tVozdushnaya": "Academy",
  NN: "MOV",
  Y4: "VOI",
  VI: "VDA",
  TV: "VEX",
  VS: "VIR",
  ZG: "VVM",
  XF: "VLK",
  LC: "VLO",
  "9V": "VPA",
  RG: "VRN",
  VG: "VLM",
  UK: "VTI",
  WT: "WSG",
  "2W": "WLC",
  WZ: "WSF",
  YH: "WCW",
  "8O": "YWZ",
  WS: "WJA",
  "ST*": "STT",
  CN: "WWD",
  WF: "WIF",
  "WIG\tWiggins": "Airways",
  WL: "WLS",
  IV: "JET",
  "7W": "QGA",
  "8Z": "WVL",
  W6: "WZZ",
  "3W*": "VNR",
  MF: "CXA",
  SE: "SEU",
  XN: "XAR",
  XP: "CXP",
  YL: "LLM",
  Y8: "YZR",
  Y0: "EMJ",
  IY: "IYE",
  Q3: "MBN",
  Z4: "OOM",
};

/**
 * Parse a TripIt date object ({date, time, utc_offset, timezone}) into a DateTimeWithTimezone.
 */
const parseTripItDateTime = (dateObj: {
  date: string;
  time: string;
  timezone: string;
  utc_offset: string;
}): DateTimeWithTimezone => {
  return {
    dateTime: new Date(
      dateObj.date + "T" + dateObj.time + dateObj.utc_offset,
    ),
    timezone: dateObj.timezone,
  };
};

/**
 * Get the ICAO ident for a flight from TripIt data.
 */
export const getIdent = (flight: FlightStatus): string => {
  let airlineCode = flight.marketing_airline_code;
  if (airlineCode in IATAToICAO) {
    airlineCode = IATAToICAO[airlineCode];
  }
  return `${airlineCode}${flight.marketing_flight_number}`;
};

/**
 * Map a TripIt FlightStatus to a DisplayFlight.
 * Status defaults to "Scheduled" / "primary" since TripIt is now reservation-only.
 */
export const mapTripItToDisplayFlight = (
  flight: FlightStatus,
): DisplayFlight => {
  const ident = getIdent(flight);

  const scheduledDepartureDateObject =
    flight.Status.ScheduledDepartureDateTime ?? flight.StartDateTime;

  const scheduledArrivalDateObject =
    flight.Status.ScheduledArrivalDateTime ?? flight.EndDateTime;

  const scheduledDeparture = parseTripItDateTime(scheduledDepartureDateObject);
  const scheduledArrival = parseTripItDateTime(scheduledArrivalDateObject);

  const estimatedDeparture = flight.Status.EstimatedDepartureDateTime
    ? parseTripItDateTime(flight.Status.EstimatedDepartureDateTime)
    : undefined;

  const estimatedArrival = flight.Status.EstimatedArrivalDateTime
    ? parseTripItDateTime(flight.Status.EstimatedArrivalDateTime)
    : undefined;

  const scheduledDateDifference = Math.abs(
    (new Date(scheduledArrivalDateObject.date).getTime() -
      new Date(scheduledDepartureDateObject.date).getTime()) /
      (1000 * 60 * 60 * 24),
  );

  const estimatedDateDifference =
    flight.Status.EstimatedDepartureDateTime &&
    flight.Status.EstimatedArrivalDateTime
      ? Math.abs(
          (new Date(flight.Status.EstimatedArrivalDateTime.date).getTime() -
            new Date(
              flight.Status.EstimatedDepartureDateTime.date,
            ).getTime()) /
            (1000 * 60 * 60 * 24),
        )
      : undefined;

  const departureDelay =
    estimatedDeparture !== undefined
      ? estimatedDeparture.dateTime.getTime() -
        scheduledDeparture.dateTime.getTime()
      : undefined;

  const arrivalDelay =
    estimatedArrival !== undefined
      ? estimatedArrival.dateTime.getTime() -
        scheduledArrival.dateTime.getTime()
      : undefined;

  return {
    ident,
    marketingAirline: flight.marketing_airline,
    marketingAirlineCode: flight.marketing_airline_code,
    marketingFlightNumber: flight.marketing_flight_number,
    startAirportCode: flight.start_airport_code,
    endAirportCode: flight.end_airport_code,
    startCityName: flight.start_city_name,
    endCityName: flight.end_city_name,
    duration: flight.duration,

    statusText: "Scheduled",
    longStatusText: "Scheduled",
    statusColor: "primary",

    scheduledDeparture,
    scheduledArrival,
    estimatedDeparture,
    estimatedArrival,

    departureTerminal: flight.Status.departure_terminal,
    departureGate: flight.Status.departure_gate,
    arrivalTerminal: flight.Status.arrival_terminal,
    arrivalGate: flight.Status.arrival_gate,
    baggageClaim: flight.Status.baggage_claim,

    departureDelay,
    arrivalDelay,

    scheduledDateDifference,
    estimatedDateDifference,

    statusSource: "tripit",
    originalTripItFlight: flight,
  };
};

/**
 * Get the local calendar date (YYYY-MM-DD) of an instant in a given timezone.
 */
const localDateString = (date: Date, timezone: string): string =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);

/**
 * Whole-day difference between two instants based on their *local* calendar
 * dates at each end's timezone (not UTC). Parsing the date-only strings as
 * UTC midnight avoids DST/offset skew.
 */
const localDayDifference = (
  departure: DateTimeWithTimezone,
  arrival: DateTimeWithTimezone,
): number =>
  Math.round(
    (new Date(localDateString(arrival.dateTime, arrival.timezone)).getTime() -
      new Date(
        localDateString(departure.dateTime, departure.timezone),
      ).getTime()) /
      (1000 * 60 * 60 * 24),
  );

/**
 * Enrich a DisplayFlight with FlightAware data.
 * Only overwrites fields when FA provides non-null values.
 */
export const enrichWithFlightAware = (
  display: DisplayFlight,
  fa: FlightAwareStatus,
): DisplayFlight => {
  // Determine status color from FA data
  let statusColor: string;
  if (fa.cancelled || fa.diverted) {
    statusColor = "danger";
  } else if (fa.arrival_delay >= 300) {
    statusColor = "danger";
  } else {
    statusColor = "success";
  }

  // Build scheduled times from FA
  const scheduledDeparture: DateTimeWithTimezone = {
    dateTime: new Date(fa.scheduled_out),
    timezone: fa.origin.timezone,
  };
  const scheduledArrival: DateTimeWithTimezone = {
    dateTime: new Date(fa.scheduled_in),
    timezone: fa.destination.timezone,
  };

  // Estimated/actual: actual → estimated → scheduled fallback
  const estimatedOutStr = fa.actual_out ?? fa.estimated_out ?? fa.scheduled_out;
  const estimatedInStr = fa.actual_in ?? fa.estimated_in ?? fa.scheduled_in;

  const estimatedDeparture: DateTimeWithTimezone = {
    dateTime: new Date(estimatedOutStr),
    timezone: fa.origin.timezone,
  };
  const estimatedArrival: DateTimeWithTimezone = {
    dateTime: new Date(estimatedInStr),
    timezone: fa.destination.timezone,
  };

  // Only show estimated times if they differ from scheduled
  const hasEstimatedDeparture =
    estimatedDeparture.dateTime.getTime() !==
    scheduledDeparture.dateTime.getTime();
  const hasEstimatedArrival =
    estimatedArrival.dateTime.getTime() !==
    scheduledArrival.dateTime.getTime();

  // Compute date differences for +1 day labels using each end's *local*
  // calendar date. Comparing the raw UTC date portions is wrong: a flight can
  // cross midnight UTC while staying on the same local day at both airports.
  const scheduledDateDifference = localDayDifference(
    scheduledDeparture,
    scheduledArrival,
  );

  const estimatedDateDifference = localDayDifference(
    estimatedDeparture,
    estimatedArrival,
  );

  return {
    ...display,

    statusText: fa.status,
    longStatusText: fa.status,
    statusColor,

    scheduledDeparture,
    scheduledArrival,
    estimatedDeparture: hasEstimatedDeparture ? estimatedDeparture : undefined,
    estimatedArrival: hasEstimatedArrival ? estimatedArrival : undefined,

    // Only override gate/terminal/baggage if FA provides non-null/non-empty
    departureTerminal: fa.terminal_origin || display.departureTerminal,
    departureGate: fa.gate_origin || display.departureGate,
    arrivalTerminal: fa.terminal_destination || display.arrivalTerminal,
    arrivalGate: fa.gate_destination || display.arrivalGate,
    baggageClaim: fa.baggage_claim || display.baggageClaim,

    departureDelay: fa.departure_delay ? fa.departure_delay * 1000 : undefined,
    arrivalDelay: fa.arrival_delay ? fa.arrival_delay * 1000 : undefined,

    scheduledDateDifference,
    estimatedDateDifference,

    faFlightId: fa.fa_flight_id,
    inboundFaFlightId: fa.inbound_fa_flight_id,
    registration: fa.registration,
    progressPercent: fa.progress_percent,

    statusSource: "flightaware",
  };
};
